
import { FormikHelpers, useFormik } from "formik";
import { useNavigate } from "react-router-dom";
import { MemberCreate } from "../member";
import { Grid, TextField, Box, FormHelperText, Paper, Button } from "@mui/material";


type MemberProps = {
  onSubmit: (
    value: MemberCreate,
    helpers: FormikHelpers<MemberCreate>
  ) => Promise<boolean>;
  submitting: boolean;
  
};

const CreateMemberForm = ({
  onSubmit,
  submitting,
  
}: MemberProps) => {
  const navigate = useNavigate();

  const handleSubmit = async (
    value: MemberCreate,
    helpers: FormikHelpers<MemberCreate>
  ) => {
    const success = await onSubmit(value, helpers);
    if (success) {
      navigate('/', { replace: true });
      navigate('/members/create', { replace: true });
    };
  };

  const initialValues: MemberCreate =  {    name: '',
    image: null,
    email: '',
    phone: '',
    linkedin: '',
    website: '',
}

  const formik = useFormik({
    initialValues,
    onSubmit: handleSubmit,
  });

  // console.log('Edit Form', initialValues);

  return (
    
<>
  <Box sx={{ flexGrow: 1, maxWidth: 800 }}>
    <form onSubmit={formik.handleSubmit}>
      <Grid container spacing={1}>
      
<Grid item>
  <Paper sx={{ p: 2, pb: 3 }}>
  <Grid container justifyContent="space-between" spacing={1} sx={{ mt: 2 }}>
<Grid item alignSelf="flex-start" sx={{ flexGrow: 1 }}>
  <TextField
    fullWidth
    name="name"
    size="small"
    type="text"
    variant="outlined"
    label="Name"
    placeholder=""
    value={formik.values.name}
    onChange={formik.handleChange}
    error={Boolean(formik.errors.name)}
    helperText={formik.errors.name}
  />
</Grid>
</Grid><Grid container justifyContent="space-between" spacing={1} sx={{ mt: 2 }}>
<Grid item alignSelf="flex-start" sx={{ flexGrow: 1 }}>
  <Grid item xs={12}>
    Image
  </Grid>
  <Box>
    <input
      type="file"
      onChange={({ target: { files } }) => {
        formik.setFieldValue(
          'image',
          files && files.length ? files[0] : null
        );
      }}
      name="image"
    />
  </Box>
  {formik.touched.image && formik.errors.image && (
    <FormHelperText error>
      {formik.errors.image}
    </FormHelperText>
  )}
</Grid>
</Grid><Grid container justifyContent="space-between" spacing={1} sx={{ mt: 2 }}>
<Grid item alignSelf="flex-start" sx={{ flexGrow: 1 }}>
  <TextField
    fullWidth
    name="email"
    size="small"
    type="text"
    variant="outlined"
    label="Email"
    placeholder=""
    value={formik.values.email}
    onChange={formik.handleChange}
    error={Boolean(formik.errors.email)}
    helperText={formik.errors.email}
  />
</Grid>

<Grid item alignSelf="flex-start" sx={{ flexGrow: 1 }}>
  <TextField
    fullWidth
    name="phone"
    size="small"
    type="text"
    variant="outlined"
    label="Phone"
    placeholder=""
    value={formik.values.phone}
    onChange={formik.handleChange}
    error={Boolean(formik.errors.phone)}
    helperText={formik.errors.phone}
  />
</Grid>
</Grid><Grid container justifyContent="space-between" spacing={1} sx={{ mt: 2 }}>
<Grid item alignSelf="flex-start" sx={{ flexGrow: 1 }}>
  <TextField
    fullWidth
    name="linkedin"
    size="small"
    type="text"
    variant="outlined"
    label="LinkedIn"
    placeholder=""
    value={formik.values.linkedin}
    onChange={formik.handleChange}
    error={Boolean(formik.errors.linkedin)}
    helperText={formik.errors.linkedin}
  />
</Grid>

<Grid item alignSelf="flex-start" sx={{ flexGrow: 1 }}>
  <TextField
    fullWidth
    name="website"
    size="small"
    type="text"
    variant="outlined"
    label="Website"
    placeholder=""
    value={formik.values.website}
    onChange={formik.handleChange}
    error={Boolean(formik.errors.website)}
    helperText={formik.errors.website}
  />
</Grid>
</Grid>

    <Grid container sx={{ mt: 2 }}>
      <Button
        type="submit"
        variant="contained"
        disabled={submitting}
        size="small"
      >
        {submitting ? 'Saving' : 'Save'}
      </Button>
    </Grid>
  </Paper>
</Grid>

      </Grid>
    </form>
  </Box>
</>
  
  );
};

export default CreateMemberForm;
